<template>
    <section class="slider-section">
        <div class="slider-row">
            <article v-for="person in currentGroupPeople" :key="person.index" class="person-card small">
                <img :src="person.image" :alt="person.name" />
                <div class="name-container">
                    <h3>{{ person.name }}</h3>
                    <p>{{ person.position }}</p>
                    <span>{{ person.about }}</span>
                </div>
            </article>
        </div>

        <div class="controls" v-if="people.length > 3">
            <button type="button" @click="prev" aria-label="Previous group">
                <img src="../../assets/logo/prev.png" alt="Previous">
            </button>
            <div class="dots" aria-hidden="true">
                <span
                    v-for="(_, index) in totalGroups"
                    :key="index"
                    class="dot"
                    :class="{ active: index === currentGroup }"
                ></span>
            </div>
            <button type="button" @click="next" aria-label="Next group">
                <img src="../../assets/logo/next.png" alt="Next">
            </button>
        </div>
    </section>
</template>

<script setup>
import { ref, computed } from "vue";
/* eslint-disable */
const props = defineProps({
    people: {
        type: Array,
        required: true,
    },
});

const currentGroup = ref(0);
const itemsPerGroup = 3;

const totalGroups = computed(() => Math.ceil(props.people.length / itemsPerGroup));

const currentGroupPeople = computed(() => {
    const startIndex = currentGroup.value * itemsPerGroup;
    return props.people.slice(startIndex, startIndex + itemsPerGroup).map((person, index) => ({
        ...person,
        index: startIndex + index
    }));
});

const next = () => {
    currentGroup.value = currentGroup.value < totalGroups.value - 1 ? currentGroup.value + 1 : 0;
};

const prev = () => {
    currentGroup.value = currentGroup.value > 0 ? currentGroup.value - 1 : totalGroups.value - 1;
};
</script>

<style lang="scss" scoped>
.slider-section {
    width: 100%;
    margin-top: 2rem;
    text-align: center;
}

.slider-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap;
}

.person-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    position: relative;
}

.person-card.small {
    width: 320px;
    height: 348px;
    transform: scale(0.9);
    cursor: pointer;
}

.person-card img {
    width: 320px;
    height: 348px;
    border-radius: 20px;
    object-fit: cover;
    display: block;
}

.name-container {
    border: 2px solid #ffffff;
    width: 95%;
    height: 88px;
    border-radius: 12px;
    background-color: #139246;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 8px;
    color: #ffffff;
}

.name-container h3 {
    margin: 0;
    padding: 0;
    font-size: 18px;
    font-weight: 700;
}

.name-container p {
    margin: 0;
    padding: 0;
    font-size: 13px;
    font-weight: 500;
    opacity: 0.95;
}

.name-container span {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.4;
    opacity: 0.95;
}

.controls {
    margin-top: 15px;
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
}

.controls button {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    border: 1px solid #00000033;
    box-shadow: 0 4px 10px rgba(58, 57, 57, 0.1);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.dots {
    display: flex;
    gap: 8px;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #d9d9d9;
}

.dot.active {
    background: #0f5b2b;
}

@media (max-width: 992px) {
    .slider-row {
        gap: 24px;
    }
}

@media (max-width: 768px) {
    .slider-row {
        flex-direction: column;
        gap: 16px;
    }
}
</style>
